module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_7016.40349561.png";